import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mapLabelsToMultiSelectOptions } from '../../../utils/map-labels-to-multi-select-options';
import { useAvailableLabels } from '../../../hooks/use-available-labels';
import { useCreateLabel } from '../../../hooks/use-create-label';
import { LabelCreatorBase } from './LabelCreatorBase';

interface LabelCreatorProps {
  className?: string;
  siteId: string | null;
}

export function LabelCreator({ className, siteId }: LabelCreatorProps): JSX.Element {
  const { t } = useTranslation();
  const { data: labels } = useAvailableLabels(siteId, 'all');
  const [labelItems, setLabelItems] = useState(mapLabelsToMultiSelectOptions(labels ?? []));

  const { createLabel } = useCreateLabel(Number(siteId));

  useEffect(() => {
    setLabelItems(mapLabelsToMultiSelectOptions(labels));
  }, [labels, setLabelItems]);

  const onAddCustomLabel = async (name: string) => {
    await createLabel(name.charAt(0).toUpperCase() + name.slice(1));
  };

  return (
    <LabelCreatorBase
      className={className}
      size="s"
      availableOptions={labelItems}
      selectedOptions={[]}
      placeholder={t('highlights:popover.search-label')}
      hasAddOption
      onAddOption={(name) => onAddCustomLabel(name)}
    />
  );
}
